export enum WidgetsPerspective {
  EMPLOYEE = 'Employee',
  MANAGER = 'Manager',
  RESPONSIBLE_MANAGER = 'ResponsibleManager',
  RESPONSIBLE_HR = 'ResponsibleHR',
}
